import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { authwsEnvironment } from '../authws-environment';
import { apiKeySummarySchema } from '../schemas/api-key-summary.schema';

/**
 * Get a list of API Keys for the current account
 * @returns Array of API Keys for the current account
 */
export function getApiKeys(this: unknown, accountName: string) {
  const params = new URLSearchParams([['accountName', accountName]]);
  return fromFetch(
    new Request(
      `${authwsEnvironment.resolve(this).apikeysUrl}?${params.toString()}`,
      {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
      }
    )
  ).pipe(selectData(z.array(apiKeySummarySchema)));
}
